import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=93090e74&scoped=true"
import script from "./FeatureCard.vue?vue&type=script&lang=js"
export * from "./FeatureCard.vue?vue&type=script&lang=js"
import style0 from "./FeatureCard.vue?vue&type=style&index=0&id=93090e74&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93090e74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93090e74')) {
      api.createRecord('93090e74', component.options)
    } else {
      api.reload('93090e74', component.options)
    }
    module.hot.accept("./FeatureCard.vue?vue&type=template&id=93090e74&scoped=true", function () {
      api.rerender('93090e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/openAI/components/FeatureCard.vue"
export default component.exports